import queryParams from './query'

const namesMap = {

}

/**
 * @see https://firebase.google.com/docs/reference/js/firebase.analytics.Analytics
 */
function logEvent() {
  let params = Array.prototype.slice.call(arguments)
  if (params.length > 0) {
    let name = params[0]
    if (namesMap[name]) {
      params[0] = namesMap[name]
    }
    params[1] = Object.assign(params[1] || {}, queryParams, {lang: 'en'})
    console.log('firebase logEvent:', params)
    window.firebaseAnalytics.logEvent.apply(window.firebaseAnalytics, params);
  }
}

document.addEventListener('click', (event) => {
  const paths = event.path || (event.composedPath && event.composedPath())
  for(let el of paths) {
    if (el.dataset && el.dataset.fbe) {
      logEvent(el.dataset.fbe)
      break
    }
  }
})

export default {
  logEvent
}
